export default __webpack_public_path__ + "static/media/LFEX-Logo.0b0dc846.png";